import React, { useState, useEffect } from 'react'
import Div100vh from 'react-div-100vh'
import HomeSvg from '../../../../assets/images/home.svg'
import './Layout.scss'

const Layout = ({ children }) => {
  const [header, setHeader] = useState('')

  useEffect(() => {
    const user = JSON.parse(localStorage.getItem('userappret'))
    setHeader(user.title)
  }, [])

  return (
    <Div100vh className='mobile-container'>
      {/* <div className='layout-app-head'>
      <div className='header-info'>
        <img src={HomeSvg} alt='homesvg'/>
        <p>{header}</p>
      </div>
      </div> */}
      {children}
    </Div100vh>
  )
}

export default Layout
